export const FETCH_BY_NAME_ERROR = 'FETCH_BY_NAME_ERROR';
export const FETCH_BY_NAME_REQUEST = 'FETCH_BY_NAME_REQUEST';
export const FETCH_BY_NAME_SUCCESS = 'FETCH_BY_NAME_SUCCESS';
